module.exports = __webpack_public_path__ + "img/map-background.1bf26ed6.svg";